class NavigationBlock {
  constructor(element) {
    this.navigation = element;

    this.menuTitle = this.navigation.querySelector('.navigation-block__title');
    this.navTrigger = this.navigation.querySelector(
      '.navigation-block__trigger'
    );
    this.navContainer = this.navigation.querySelector('.navigation-block__nav');
    this.menuItems = this.navigation.querySelectorAll(
      'li.menu-item-has-children, li.has-mega-menu'
    );
    this.subMenuToggles = this.navigation.querySelectorAll('.submenu-toggle');

    this.isMobileView = window.innerWidth < 992;
    this.timers = new Map();

    this.config = {
      mobileBreakpoint: 992,
      hoverDelay: 200,
      hoverLeaveDelay: 300,
    };
  }

  init() {
    if (!this.navigation) return;

    this.setupEventListeners();
    this.updateViewMode();
    this.setupInitialAriaStates();
  }

  setupEventListeners() {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.handleResize.bind(this), 150);
    });

    if (this.navTrigger) {
      this.navTrigger.addEventListener('click', this.toggleMainMenu.bind(this));
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllSubmenus();
      }
    });

    // Zmodyfikowane: W widoku desktopowym (po rezygnacji z hover),
    // kliknięcie poza nawigacją powinno zamykać tylko sub-menu,
    // jeśli main menu nie jest otwarte w trybie mobilnym.
    document.addEventListener('click', (e) => {
      if (!this.navigation.contains(e.target)) {
        // Sprawdzenie, czy main menu jest otwarte (tylko w trybie mobilnym)
        const isMainMenuOpen =
          this.navContainer && this.navContainer.classList.contains('is-open');

        // Jeśli menu główne jest otwarte, kliknięcie poza nim powinno je zamknąć (jak obecne zachowanie)
        // Jeśli nie jest otwarte, kliknięcie poza nawigacją powinno zamknąć tylko pod-menu.
        if (this.isMobileView && isMainMenuOpen) {
          this.toggleMainMenu(); // Zamknij menu główne w trybie mobilnym
        } else if (!this.isMobileView) {
          // W trybie desktopowym, po rezygnacji z hover, zamykamy pod-menu na kliknięcie poza.
          this.closeAllSubmenus();
        }
      }
    });

    this.navigation.addEventListener('click', (e) => {
      const button = e.target.closest('.mega-menu-back-button');
      if (button) {
        e.preventDefault();
        e.stopPropagation();

        const menuItem = button.closest('li.menu-item--open');
        if (menuItem) {
          this.closeSubmenu(menuItem);
        }
        return;
      }

      const closeBtn = e.target.closest('.mega-menu-header__close');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        window.location.reload(); // refresh page
      }
    });

    this.setupMenuItemHandlers();
  }

  setupMenuItemHandlers() {
    // ... (pozostała część metody bez zmian, zachowuje tworzenie nowych elementów)
    this.menuItems.forEach((item) => {
      const link = item.querySelector('a:first-of-type');
      const subMenu = item.querySelector('.sub-menu, .mega-menu-container');
      const toggle = item.querySelector('.submenu-toggle');

      if (!subMenu || !link) return;

      const newItem = item.cloneNode(true);
      item.parentNode.replaceChild(newItem, item);
      this.attachHandlersToItem(newItem);
    });
  }

  attachHandlersToItem(item) {
    const link = item.querySelector('a:first-of-type');
    const subMenu = item.querySelector('.sub-menu, .mega-menu-container');
    const toggle = item.querySelector('.submenu-toggle');

    // 1. Obsługa kliknięcia na przycisk przełączający (toggle)
    if (toggle) {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleSubmenu(item);
      });
    }

    // 2. Obsługa kliknięcia na główny link w elemencie menu
    // Działa zarówno w trybie mobilnym, jak i desktopowym, aby otworzyć menu
    if (subMenu) {
      // Sprawdzenie, czy element ma podmenu
      // Dodajemy obsługę kliknięcia na link w każdym widoku
      link.addEventListener('click', (e) => {
        // Zapobiegamy domyślnej akcji (przejściu do linku)
        e.preventDefault();
        e.stopPropagation();

        // Otwieramy/zamykamy podmenu
        this.toggleSubmenu(item);
      });
    }

    // Usunięcie lub zakomentowanie logiki opartej na hover i focusout dla desktopu
    /*
    if (!this.isMobileView) {
      item.addEventListener('mouseenter', () => {
        this.clearHoverTimer(item);
        const timerId = setTimeout(() => {
          this.openSubmenu(item);
        }, this.config.hoverDelay);
        this.timers.set(item, timerId);
      });

      item.addEventListener('mouseleave', () => {
        this.clearHoverTimer(item);
        const timerId = setTimeout(() => {
          if (!subMenu.matches(':hover')) {
            this.closeSubmenu(item);
          }
        }, this.config.hoverLeaveDelay);
        this.timers.set(item, timerId);
      });

      link.addEventListener('focus', () => this.openSubmenu(item));

      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) {
          this.closeSubmenu(item);
        }
      });
    } else {
      // Zachowanie mobilne dla linku bez dedykowanego toggle (nie zmieniamy)
      link.addEventListener('click', (e) => {
        if (
          !toggle &&
          (item.classList.contains('menu-item-has-children') ||
            item.classList.contains('has-mega-menu'))
        ) {
          e.preventDefault();
          this.toggleSubmenu(item);
        }
      });
    }
    */

    // Nowa logika dla widoku desktopowego po usunięciu obsługi hover:
    if (!this.isMobileView) {
      // Dodatkowa obsługa dla ułatwienia dostępu (Focus/Tab) w widoku desktopowym:
      // Otwiera menu na focus, aby było dostępne z klawiatury

      // link.addEventListener('focus', () => {
      //   const isOpen = item.classList.contains('menu-item--open');

      //   console.log('Focus on link:', link.textContent, 'Is open:', isOpen);

      //   if (!isOpen) {
      //     this.openSubmenu(item);
      //   }
      // });

      // Zamyka menu po przejściu fokusu poza element menu (menuItem)
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) {
          // Dodajemy małe opóźnienie, aby uniknąć natychmiastowego zamknięcia
          // podczas przechodzenia fokusu na elementy wewnątrz podmenu.
          setTimeout(() => {
            if (!item.contains(document.activeElement)) {
              this.closeSubmenu(item);
            }
          }, 10);
        }
      });
    }

    // Logika mobilna zostaje domyślnie zaimplementowana w punkcie 2,
    // poprzez nadpisanie link.addEventListener('click')
    // oraz w oryginalnej, niezmienionej części kodu (jeśli link nie ma toggle).
    // Uproszczona wersja mobilna może wyglądać tak (jeśli chcemy zachować dotychczasową logikę mobilną):
    if (this.isMobileView && subMenu) {
      // Jeśli link nie ma toggle, i ma podmenu, kliknięcie toggle'uje
      if (!toggle) {
        link.addEventListener('click', (e) => {
          if (
            item.classList.contains('menu-item-has-children') ||
            item.classList.contains('has-mega-menu')
          ) {
            e.preventDefault();
            this.toggleSubmenu(item);
          }
        });
      }
    }
  }

  // ... (pozostałe metody bez zmian)
  setupInitialAriaStates() {
    const allSubMenus = this.navigation.querySelectorAll(
      '.sub-menu, .mega-menu-container'
    );
    allSubMenus.forEach((menu) => {
      menu.setAttribute('inert', '');
      menu.setAttribute('hidden', '');
    });

    this.menuItems.forEach((item) => {
      const link = item.querySelector('a:first-of-type');
      const toggle = item.querySelector('.submenu-toggle');
      link?.setAttribute('aria-expanded', 'false');
      toggle?.setAttribute('aria-expanded', 'false');
    });
  }

  handleResize() {
    const newIsMobileView = window.innerWidth < this.config.mobileBreakpoint;
    if (this.isMobileView !== newIsMobileView) {
      this.isMobileView = newIsMobileView;
      this.closeAllSubmenus();
      this.updateViewMode();
      this.setupMenuItemHandlers();
    }
  }

  updateViewMode() {
    if (this.isMobileView) {
      this.navigation.classList.add('is-mobile-view');
      this.navigation.classList.remove('is-desktop-view');
    } else {
      this.navigation.classList.remove('is-mobile-view');
      this.navigation.classList.add('is-desktop-view');
    }
  }

  toggleMainMenu() {
    if (!this.navContainer) return;
    const isOpen = this.navContainer.classList.contains('is-open');
    this.navContainer.classList.toggle('is-open');
    this.navTrigger.setAttribute('aria-expanded', !isOpen);
    if (isOpen) {
      this.closeAllSubmenus();
    }
  }

  toggleSubmenu(menuItem) {
    const isOpen = menuItem.classList.contains('menu-item--open');
    if (isOpen) {
      this.closeSubmenu(menuItem);
    } else {
      this.openSubmenu(menuItem);
    }
  }

  openSubmenu(menuItem) {
    const parentUl = menuItem.parentElement;
    Array.from(parentUl.children).forEach((sibling) => {
      if (
        sibling !== menuItem &&
        sibling.classList.contains('menu-item--open')
      ) {
        this.closeSubmenu(sibling);
      }
    });

    const link = menuItem.querySelector('a:first-of-type');
    const toggle = menuItem.querySelector('.submenu-toggle');
    const subMenu = menuItem.querySelector('.sub-menu, .mega-menu-container');

    menuItem.classList.add('menu-item--open');
    link?.setAttribute('aria-expanded', 'true');
    toggle?.setAttribute('aria-expanded', 'true');
    if (subMenu) {
      subMenu.removeAttribute('hidden');
      subMenu.removeAttribute('inert');
    }
  }

  closeSubmenu(menuItem) {
    if (!menuItem || !menuItem.classList.contains('menu-item--open')) return;

    const link = menuItem.querySelector('a:first-of-type');
    const toggle = menuItem.querySelector('.submenu-toggle');
    const subMenu = menuItem.querySelector('.sub-menu, .mega-menu-container');

    menuItem.classList.remove('menu-item--open');
    link?.setAttribute('aria-expanded', 'false');
    toggle?.setAttribute('aria-expanded', 'false');
    if (subMenu) {
      subMenu.setAttribute('hidden', '');
      subMenu.setAttribute('inert', '');
    }
  }

  closeAllSubmenus() {
    this.navigation.querySelectorAll('.menu-item--open').forEach((item) => {
      this.closeSubmenu(item);
    });
  }

  clearHoverTimer(item) {
    if (this.timers.has(item)) {
      clearTimeout(this.timers.get(item));
      this.timers.delete(item);
    }
  }
}

// Inicjalizacja
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.navigation-block').forEach((element) => {
    const instance = new NavigationBlock(element);
    instance.init();
    element.navigationBlockInstance = instance;
  });
});
